import React from 'react'
import PropTypes from 'prop-types'

import Link from 'next/link'

import { ReadMoreButton } from 'Components/Blocks/_Legacy'
import { Image, Text } from 'Components/UI'
import View from 'Components/UI/_Legacy/View'
import { DateTime } from 'luxon'

import { BLOG_POST } from 'Constants/Paths'

import {
  BlogLink,
  ClockIcon,
  Container,
  Content,
  FooterContent,
  ImageHolder,
  MainContent,
} from './styles'

function Post({ data }) {
  // setZone: render the post's own calendar day in every runtime (server
  // prerenders in UTC, browsers hydrate in the visitor's zone — a local-zone
  // format mismatches on hydration, React #418).
  const published = data?.date
    ? DateTime.fromISO(data.date, { setZone: true }).toFormat('MMMM dd, yyyy')
    : null
  const readingTime = data?.readingTime

  return (
    <Container>
      {/* The card's image link wraps a deliberately decorative image, so it
          needs its own accessible name — the title link next to it carries
          the visible text. */}
      <Link aria-label={data?.title} href={BLOG_POST(data?.permalink)} passHref>
        <ImageHolder>
          <Image
            alt=""
            image={data?.imageNotLastPublished || data?.image}
            lazy
          />
        </ImageHolder>
      </Link>

      <Content>
        <MainContent>
          <BlogLink href={BLOG_POST(data?.permalink)} passHref>
            <Text
              as="h2"
              fontSize={[18, 24]}
              letterSpacing={0.67}
              lineHeight={1.38}
              medium
            >
              {data?.title}
            </Text>
          </BlogLink>

          <Text light mt={[16, 30]}>
            {data?.excerpt}
          </Text>
        </MainContent>

        <FooterContent mt={[32, 55]}>
          {published && (
            <Text as="time" center dateTime={data?.date} light>
              {published}
            </Text>
          )}

          {readingTime && (
            <Text light ml={[0, 16]}>
              <ClockIcon />
              {readingTime} minutes
            </Text>
          )}

          <View.Desktop>
            <ReadMoreButton href={BLOG_POST(data?.permalink)} />
          </View.Desktop>
        </FooterContent>
      </Content>
    </Container>
  )
}

Post.defaultProps = {
  data: null,
}

Post.propTypes = {
  data: PropTypes.object,
}

export default Post
